// Which chat_sessions rows a therapist should see.
//
// Two kinds of row are never a client's conversation and used to leak into
// Chat Summaries, the risk and theme aggregates and the export:
//   - is_deleted rows: soft-deleted by the client in MindVault, plus the
//     greeting-only "summaries" written before MindVault stopped ending idle
//     sessions that nobody had spoken in. Every chat_sessions query adds
//     .eq('is_deleted', false).
//   - session_type 'ai_assistant': the client's therapist-recommendation Q&A.
//     Client-linked queries (by user_id) add .or(CLIENT_CHAT_SESSION_TYPES);
//     kiosk queries (team_id, user_id null) can't contain it.
export const AI_ASSISTANT_SESSION_TYPE = 'ai_assistant';

// Rows older than the session_type column are null, so a plain neq would drop them.
export const CLIENT_CHAT_SESSION_TYPES = `session_type.is.null,session_type.neq.${AI_ASSISTANT_SESSION_TYPE}`;
